<template>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p class="mb-0">Registrar Pago</p>
              </div>
            </div>
            <div class="card-body">
              <!-- <div class="mb-3">
                <label>Seleccionar préstamo</label>
                <select class="form-control" v-model="selectedLoanId" @change="loadPaymentPlan">
                  <option v-for="loan in loans" :key="loan.id" :value="loan.id">
                    {{ loan.client_name }} - #{{ loan.id }}
                  </option>
                </select>
              </div>
   -->
              <div v-if="paymentPlan.length">
                <label>Monto pagado</label>
                <argon-input v-model="paymentAmount" type="number" step="0.01" />
  
                <argon-button class="mt-3" color="success" @click="processPayment">
                  Registrar pago
                </argon-button>
  
                <!-- <div class="mt-4">
                  <h5>Detalle del próximo pago</h5>
                  <p>Fecha: {{ nextDue.date }}</p>
                  <p>Total a pagar: {{ nextDue.total }}</p>
                  <p>Capital: {{ nextDue.capital }}</p>
                  <p>Interés: {{ nextDue.interest }}</p>
                </div> -->
                <div class="col-md-12">
                                    <div class="table-responsive p-0">
                                        <label for="example-text-input" class="form-control-label"
                                        >PLAN DE PAGOS</label
                                        >
                                        <table class="table align-items-center mb-0">
                                        <thead>
                                            <tr>
                                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">No.</th>
                                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha</th>
                                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Capital</th>
                                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Interés</th>
                                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Interés moratorio</th>
                                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cargos</th>
                                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Total</th>
                                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Total pagado</th>
                                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Estado</th>
                                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha de pago</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in paymentPlan" :key="index">
                                            <td>{{ item.number }}</td>
                                            <td>{{ item.date }}</td>
                                            <td class="text-end">{{ item.capital}}</td>
                                            <td class="text-end">{{ item.interest }}</td>
                                            <td class="text-end">{{ (item.late_interest||0)}}</td>
                                            <td class="text-end">{{ (item.charges ||0.00)}}</td>
                                            <td class="text-end">{{ item.total}}</td>
                                            <td class="text-end">{{ (item.payed_amount||0.00)}}</td>
                                            <td>
                                                <span v-if="item.payed === 0" class="text-warning">Pendiente</span>
                                                <span v-if="item.payed === 2" class="text-warning">Parcial</span>
                                                <span v-if="item.payed === 1" class="text-success">Pagado</span>
                                            </td>
                                            <td>{{ item.payed_date ? item.payed_date : 'N/A' }}</td>
                                            </tr>
                                        </tbody>
                                        </table>
                                    </div>
                                </div>
              </div>
              <p v-else class="text-muted">Seleccione un préstamo para ver su plan de pagos.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import ArgonInput from "@/components/ArgonInput.vue";
  import ArgonButton from "@/components/ArgonButton.vue";
  import axios from "axios";
  
  export default {
    name: "PaymentRegister",
    components: { ArgonInput, ArgonButton },
    data() {
      return {
        loans:{

        },
        paymentPlan: [],
        selectedLoanId: this.$route.params.id,
        paymentAmount: 0,
        nextDue: {},
      };
    },
    methods: {
      async fetchLoans() {
        const token = localStorage.getItem("accessToken");
        const config = { headers: { "X-Authorization": `Bearer ${token}` } };
        const response = await axios.get(this.$store.state.apiURL + "view/loans/"+this.selectedLoanId, config);
        this.loans = response.data.loans;
        console.log(this.loans)
      },
      async loadPaymentPlan() {
        const token = localStorage.getItem("accessToken");
        const config = { headers: { "X-Authorization": `Bearer ${token}` } };
        const response = await axios.get(`${this.$store.state.apiURL}list/payment_plan?loand_id=${this.selectedLoanId}&sort=number&order=ASC&recperpage=all`, config);
        console.log(response)
        this.paymentPlan = response.data.payment_plan.sort((a,b)=> a.number-b.number);
        let paymentPendant=response.data.payment_plan.sort((a,b)=> a.number-b.number).filter(p => !p.payed);
        this.nextDue =paymentPendant[0] || {};
      },
      
      async processPayment() {
        let amountLeft = parseFloat(this.paymentAmount); // Monto total a pagar
        const today = new Date(); // Fecha actual para el pago

        for (let i = 0; i < this.paymentPlan.length && amountLeft > 0; i++) {
            const due = this.paymentPlan[i];
            if (due.payed) continue; // Si ya está pagado, pasamos a la siguiente cuota

            //const dueDate = new Date(due.date);
            //const diffDays = Math.floor((today - dueDate) / (1000 * 60 * 60 * 24)); // Días de atraso

            // Obtener valores originales
            let capitalOriginal = parseFloat(due.capital) || 0;
            let chargesOriginal = parseFloat(due.charges) || 0;
            let interestOriginal = parseFloat(due.interest) || 0;

            //const moratoryRate = parseFloat(this.loans.late_interest || 0) / 100;

            // Calcular el interés moratorio si aplica
            let lateInterestOriginal = 0;
           /*  if (diffDays > 0) {
                lateInterestOriginal = capitalOriginal * moratoryRate * diffDays;
            } */

            // Restantes para pagar en cada concepto
            let chargesRemaining = chargesOriginal;
            let lateInterestRemaining = lateInterestOriginal;
            let interestRemaining = interestOriginal;
            let capitalRemaining = capitalOriginal;

            // Variables para aplicar pagos
            let paidCharges = 0;
            let paidLateInterest = 0;
            let paidInterest = 0;
            let paidCapital = 0;
            console.log(amountLeft);
            // Primero pagar los **cargos**
            if (amountLeft > 0 && chargesRemaining > 0) {
                paidCharges = Math.min(chargesRemaining, amountLeft);
                chargesRemaining -= paidCharges;
                amountLeft -= paidCharges;
            }
            console.log(amountLeft);
            // Luego pagar el **interés moratorio** (si hay)
            if (amountLeft > 0 && lateInterestRemaining > 0) {
                paidLateInterest = Math.min(lateInterestRemaining, amountLeft);
                lateInterestRemaining -= paidLateInterest;
                amountLeft -= paidLateInterest;
            }
            console.log(amountLeft);
            // Luego pagar el **interés corriente**
            if (amountLeft > 0 && interestRemaining > 0) {
                paidInterest = Math.min(interestRemaining, amountLeft);
                interestRemaining -= paidInterest;
                amountLeft -= paidInterest;
            }
            console.log(amountLeft);
            // Finalmente pagar el **capital** (si queda saldo)
            if (amountLeft > 0 && capitalRemaining > 0) {
                paidCapital = Math.min(capitalRemaining, amountLeft);
                capitalRemaining -= paidCapital;
                amountLeft -= paidCapital;
            }
            console.log(amountLeft);
            // Si todavía queda saldo por pagar, asegurarse de ajustar el capital completamente
            if (amountLeft > 0 && capitalRemaining > 0) {
                paidCapital += amountLeft; // Aplica el saldo restante a capital
                capitalRemaining -= amountLeft;
                amountLeft = 0; // Ya no queda saldo por pagar
            }
            console.log(amountLeft);
            // Total original a pagar en esta cuota
            const totalOriginal = chargesOriginal + lateInterestOriginal + interestOriginal + capitalOriginal;

            // Total pagado en esta cuota
            const totalPaid = paidCharges + paidLateInterest + paidInterest + paidCapital;

            // Actualizamos el estado: 1=pagado completamente, 2=pagado parcialmente, 0=no pagado
            let payedStatus = 0;
            if (totalPaid >= totalOriginal) {
                payedStatus = 1; // Pagado completamente
            } else if (totalPaid > 0) {
                payedStatus = 2; // Pagado parcialmente
            }

            // Actualizamos la cuota con los valores reflejando lo pagado y lo restante
            this.paymentPlan[i] = {
                ...due,
                payed: payedStatus,
                payed_date: totalPaid > 0 ? today.toISOString().split('T')[0] : null,
                state: payedStatus === 1 ? 1 : 2,
                charges: chargesRemaining.toFixed(2),
                late_interest: lateInterestRemaining.toFixed(2),
                interest: interestRemaining.toFixed(2),
                capital: capitalRemaining.toFixed(2),
                payed_amount: totalPaid.toFixed(2),
            };

            // Si no se pagó completamente esta cuota, pasamos al siguiente pago
            if (totalPaid < totalOriginal) {
                break; // Salimos si la cuota no está completamente pagada
            }
        }

        // Informar al usuario que el pago fue procesado en memoria
        this.$swal({
            title: 'Pago simulado',
            text: 'El pago fue aplicado en memoria.',
            icon: 'info',
            confirmButtonColor: '#0b9257'
        });

        // Resetear monto de pago para futuras operaciones
        this.paymentAmount = 0;

        // Actualizar próxima cuota pendiente
        this.nextDue = this.paymentPlan.find(p => !p.payed || p.payed === 2) || {};
    }


    },
    async mounted() {
      await this.fetchLoans();
      await this.loadPaymentPlan();
    }
  };
  </script>
  